import {useQuery} from 'react-query'
import {KTCard} from '../../../../_metronic/helpers'
import {BASE_URL} from '../../config'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import axios from 'axios'
import {useEffect, useState} from 'react'
import {ILink} from './_modal'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import linkListColumn from './linkLIstColumn'

type Props = {
  searchTerm: string
  onSelectLink: (link: ILink) => void
}

export const GET_LINKS_URL = `${BASE_URL}/api/protect/getAllLink`

const LinkList = ({searchTerm, onSelectLink}: Props) => {
  const {
    pagination: {totalElement, page, size},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)

  const [linkList, setLinkList] = useState<ILink[]>([])

  const {isLoading, data, error} = useQuery({
    queryKey: ['linkList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_LINKS_URL, {params: {page, size}})
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
  })

  const handleSelect = (id: number) => {
    const selected = linkList.find((link) => link.link_id === id)

    if (selected) {
      onSelectLink(selected)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof ILink)[] = ['link_name', 'link_value']
      const filtered = searchItems(data.list, searchTerm, keys)

      setLinkList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [data])

  return (
    <ListViewProvider isLoading={isLoading} data={linkList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
      <>
        <TableContent
          isLoading={isLoading}
          tableData={linkList}
          tableColumn={linkListColumn(handleSelect)}
          error={error as Error}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </>
    </ListViewProvider>
  )
}

export default LinkList
